import { computed, Ref, ComputedRef, SetupContext } from '@vue/composition-api';
import {
  MaterialType,
  MaterialLibrarySortOptions,
  NativeMaterialLibrarySortOptions,
  NativeMaterialLibraryFilterOptions,
  AffiliateVideoSearchType,
} from '@tt4b/ttam-enums';

export function useSearch(
  param: Ref<{
    keyword: string;
    keywordType?: AffiliateVideoSearchType;
    sortType: number | boolean;
    filterTypes: number[];
    page: number;
    totalPage: number;
  }>,
  isNativeType: ComputedRef<boolean>,
  { emit }: SetupContext,
) {
  /** filter */
  const filterOptions = NativeMaterialLibraryFilterOptions();
  const keyword = computed(() => param.value.keyword ?? '');
  const keywordType = computed(() => param.value.keywordType ?? AffiliateVideoSearchType.Undefined);
  const defaultFilterType = [filterOptions[1]?.children[0]?.id || 1];
  const filterTypes = computed(() => param.value.filterTypes || defaultFilterType);
  /** sort */
  const defaultSortType = isNativeType.value
    ? NativeMaterialLibrarySortOptions()[0].value
    : MaterialLibrarySortOptions()[0].value;
  const sortType = computed(() => param.value.sortType ?? defaultSortType);
  const sortOptions = computed(() =>
    isNativeType.value ? NativeMaterialLibrarySortOptions() : MaterialLibrarySortOptions(),
  );

  /** page */
  const page = computed(() => param.value.page || 1);
  const totalPage = computed(() => param.value.totalPage || 1);

  function onParamChange(data = {}) {
    emit('param-change', {
      keyword: keyword.value,
      keywordType: keywordType.value,
      sortType: sortType.value,
      filterTypes: filterTypes.value,
      page: page.value,
      totalPage: totalPage.value,
      ...data,
    });
  }

  function onVideoSourceChange(val: MaterialType) {
    emit('video-source-change', val);
  }

  return {
    keyword,
    keywordType,
    sortType,
    sortOptions,
    filterTypes,
    filterOptions,
    onParamChange,
    onVideoSourceChange,
  };
}
